import { API_URL } from "config";
import Http from "util/https";
import { downloadFromUrl } from "../utils/common";
import { SearchApiParams } from "../types";

/**
 * ダウンロードするURLを取得
 * @param params 絞込検索パラメータ
 */
export default async function downloadOrderAskCsv(params: SearchApiParams) {
  console.log(`downloadOrderAskCsv`);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/product/csv/download`;
  const res = await http.post(url, params);
  console.log(res);

  // const res: {data: {url: string}} = {data: {url: 'https://sample-videos.com/csv/Sample-Spreadsheet-10-rows.csv'}}

  // downloadFromUrl(res.data.url, '注文依頼データ');
  downloadFromUrl(res.data.url, '注文依頼データ');

  return res.data;
}